'use client';
import { COLORS } from '@/common/constants';
import { checkType, formatDateVN } from '@/common/ultils';
import get from 'lodash/get';
import Sidebar from '@/components/Sidebar';
import { ClockCircleOutlined } from '@ant-design/icons';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useParams, usePathname, useRouter, useSearchParams } from 'next/navigation';
import React from 'react';
import { twMerge } from 'tailwind-merge';

const PostsByShowcaseWall = ({ postss, rightBanners, linkPages, websiteCode, showcaseWall, deviceType = 'mobile' }) => {
  const t = useTranslations('');
  const router = useRouter();
  const { slug } = useParams();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const totalPages = postss.totalPages || 0;
  const currentPage = postss.page || 1;
  const posts1 = get(postss, 'results[0]');
  const posts2 = get(postss, 'results[1]');
  const posts3 = get(postss, 'results[2]');

  const handleChangePage = (page) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('page', page);
    router.push(`${pathname}?${newParams.toString()}`);
  };
  let titlePage = '';
  for (let i = 0; i < get(postss, 'results', []).length; i++) {
    if (titlePage === '') {
      const posts = get(postss, 'results', [])[i];
      titlePage = get(posts, 'menu.name', '');
    }
  }

  return (
    <div className="flex flex-col min-h-screen">
      <div className="container mx-auto grow bg-white px-2 md:px-4 pt-2  py-1">
        <div className="flex flex-col lg:flex-row gap-6">
          <main className="lg:w-3/4 ">
            <div className="flex items-center">
              <h1 className="text-xl font-bold !text-black mb-4 ">
                <button
                  className={twMerge('cursor-pointer', COLORS.primary)}
                  onClick={() => {
                    router.back();
                  }}>
                  {titlePage || 'Trang chủ'}
                </button>
                /{showcaseWall?.desc ?? ''}
              </h1>
            </div>
            <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-3">
              {posts1 && (
                <div className="md:col-span-2 bg-white shadow rounded-lg overflow-hidden">
                  <div className="w-full aspect-video items-center flex justify-center bg-gray-100 box-border overflow-hidden">
                    <img
                      src={posts1?.imgaeUrls ? checkType(deviceType === 'mobile' ? 'mobile' : 'tablet', posts1) : `/img-default.png`}
                      className={twMerge(
                        'object-cover hover:scale-105 transition-transform duration-300',
                        posts1?.imgaeUrls ? 'w-full h-full' : 'w-12.5 h-12.5 my-5',
                      )}
                      alt="image"
                    />
                  </div>
                  <div className="p-5">
                    <Link
                      className={twMerge(
                        'hover:underline text-2xl leading-tight font-semibold mb-2 transition-colors line-clamp-2',
                        COLORS.greenLightHover,
                      )}
                      href={websiteCode ? `/sub/${websiteCode}/${slug}/${posts1?.slug}` : `/${slug}/${posts1?.slug}`}>
                      {posts1.title}
                    </Link>

                    <div className="flex justify-between text-gray-500 italic text-sm">
                      <p className="text-gray-500 text-sm mb-3">
                        <ClockCircleOutlined className="mr-1" />
                        {!!(posts1?.postedDate ?? posts1?.date) ? formatDateVN(posts1?.postedDate ?? posts1?.date) : ''}
                      </p>
                      <span>Nguồn: {posts1?.source?.name ?? posts1?.createdBy?.name ?? 'admin'}</span>
                    </div>
                    <div className="boldish-text text-justify line-clamp-12" dangerouslySetInnerHTML={{ __html: posts1?.summary ?? '' }} />
                  </div>
                </div>
              )}

              <div className="flex flex-col gap-6">
                {posts2 && (
                  <div className="bg-white shadow rounded-lg overflow-hidden">
                    <div className="w-full aspect-video items-center flex justify-center bg-gray-100 box-border overflow-hidden">
                      <img
                        src={posts2?.imgaeUrls ? checkType(deviceType === 'mobile' ? 'mobile' : 'tablet', posts2) : `/img-default.png`}
                        className={twMerge(
                          'object-cover hover:scale-105 transition-transform duration-300',
                          posts2?.imgaeUrls ? 'w-full h-full' : 'w-12.5 h-12.5 my-5',
                        )}
                        alt="image"
                      />
                    </div>
                    <div className="p-4">
                      <Link
                        className={twMerge(
                          'hover:underline text-lg leading-tight font-semibold mb-2 transition-colors line-clamp-2',
                          COLORS.greenLightHover,
                        )}
                        href={websiteCode ? `/sub/${websiteCode}/${slug}/${posts2?.slug}` : `/${slug}/${posts2?.slug}`}>
                        {posts2.title}
                      </Link>

                      <div className="mt-1 flex justify-between text-gray-500 italic text-xs">
                        <p className="text-gray-500 mb-3">
                          <ClockCircleOutlined className="mr-1" />
                          {!!(posts2?.postedDate ?? posts2?.date) ? formatDateVN(posts2?.postedDate ?? posts2?.date) : ''}
                        </p>
                        <span>Nguồn: {posts2?.source?.name ?? posts2?.createdBy?.name ?? 'admin'}</span>
                      </div>
                      <div className="boldish-text text-justify line-clamp-2" dangerouslySetInnerHTML={{ __html: posts2?.summary ?? '' }} />
                    </div>
                  </div>
                )}

                {posts3 && (
                  <div className="bg-white shadow rounded-lg overflow-hidden">
                    <div className="w-full aspect-video items-center flex justify-center bg-gray-100 box-border overflow-hidden">
                      <img
                        src={posts3?.imgaeUrls ? checkType(deviceType === 'mobile' ? 'mobile' : 'tablet', posts3) : `/img-default.png`}
                        className={twMerge(
                          'object-cover hover:scale-105 transition-transform duration-300',
                          posts3?.imgaeUrls ? 'w-full h-full' : 'w-12.5 h-12.5 my-5',
                        )}
                        alt="image"
                      />
                    </div>
                    <div className="p-4">
                      <Link
                        className={twMerge(
                          'hover:underline text-lg leading-tight font-semibold mb-2 transition-colors line-clamp-2',
                          COLORS.greenLightHover,
                        )}
                        href={websiteCode ? `/sub/${websiteCode}/${slug}/${posts3?.slug}` : `/${slug}/${posts3?.slug}`}>
                        {posts3.title}
                      </Link>
                      <div className="mt-1 flex justify-between text-gray-500 italic text-sm">
                        <p className="text-gray-500 mb-3">
                          <ClockCircleOutlined className="mr-1" />
                          {!!(posts3?.postedDate ?? posts3?.date) ? formatDateVN(posts3?.postedDate ?? posts3?.date) : ''}
                        </p>
                        <span>Nguồn: {posts3?.source?.name ?? posts3?.createdBy?.name ?? 'admin'}</span>
                      </div>
                      <div className="boldish-text text-justify line-clamp-2" dangerouslySetInnerHTML={{ __html: posts3?.summary ?? '' }} />
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="mb-8 mt-3 flex flex-wrap items-center justify-start">
              {get(postss, 'results', []).length ? (
                <div className="flex flex-col">
                  {get(postss, 'results', [])
                    .slice(3)
                    .map((posts) => (
                      <article key={posts.id} className="w-full mb-6 shadow rounded-lg overflow-hidden bg-white flex md:flex-row flex-col">
                        <div className="flex aspect-video bg-gray-100 justify-center items-center box-border overflow-hidden w-full md:w-[256px] md:min-w-[256px]">
                          <img
                            src={posts?.imgaeUrls ? checkType(deviceType === 'mobile' ? 'mobile' : 'tablet', posts) : `/img-default.png`}
                            alt={posts.title || 'Ảnh thumbnail'}
                            className={twMerge(
                              'object-cover hover:scale-105 transition-transform duration-300',
                              posts?.imgaeUrls ? 'w-full h-auto' : 'w-12.5 h-12.5 my-5',
                            )}
                          />
                        </div>

                        <div className="p-4 flex flex-col justify-between flex-grow">
                          <Link
                            className={twMerge('hover:underline text-xl font-semibold mb-2 transition-colors line-clamp-2', COLORS.greenLightHover)}
                            href={websiteCode ? `/sub/${websiteCode}/${slug}/${posts?.slug}` : `/${slug}/${posts?.slug}`}>
                            {posts.title}
                          </Link>
                          <div className="boldish-text text-justify line-clamp-3" dangerouslySetInnerHTML={{ __html: posts?.summary ?? '' }} />
                          <div className="mt-2 text-gray-500 text-xs mb-3 flex justify-between italic">
                            <div className="mr-7">
                              <ClockCircleOutlined className="mr-1" />
                              {!!(posts?.postedDate ?? posts?.date) ? formatDateVN(posts?.postedDate ?? posts?.date) : ''}
                            </div>

                            <span>Nguồn: {posts?.source?.name ?? posts?.createdBy?.name ?? 'admin'}</span>
                          </div>
                        </div>
                      </article>
                    ))}
                </div>
              ) : (
                <p className="text-md font-normal text-black mb-3">{t('news.noData')}</p>
              )}

              {totalPages > 1 && (
                <div className="mt-4 flex flex-wrap justify-center space-x-2 w-full">
                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter((page) => {
                      return (
                        page <= 3 || // 3 đầu
                        page > totalPages - 3 || // 3 cuối
                        (page >= currentPage - 1 && page <= currentPage + 1) // xung quanh trang hiện tại
                      );
                    })
                    .reduce((acc, page, i, arr) => {
                      if (i > 0 && page - arr[i - 1] > 1) {
                        acc.push('ellipsis-' + i); // Dùng key khác biệt
                      }
                      acc.push(page);
                      return acc;
                    }, [])
                    .map((item) => {
                      if (typeof item === 'string' && item.startsWith('ellipsis')) {
                        const middle = Math.floor(totalPages / 2);
                        return (
                          <button
                            key={item}
                            onClick={() => handleChangePage(middle)}
                            className="px-3 py-1 border rounded bg-white text-gray-500 border-gray-300">
                            ...
                          </button>
                        );
                      } else {
                        return (
                          <button
                            key={item}
                            onClick={() => handleChangePage(item)}
                            className={`px-3 py-1 border rounded ${
                              currentPage === item ? 'bg-red-600 text-white' : 'bg-white text-gray-700 border-gray-300'
                            }`}>
                            {item}
                          </button>
                        );
                      }
                    })}
                </div>
              )}
            </div>
          </main>

          <div className="w-full md:w-1/4 ">
            <Sidebar rightBanners={rightBanners} linkPages={linkPages} websiteCode={websiteCode} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostsByShowcaseWall;
